import {
    ActionDescription,
    ActionKind,
    InputOutputTables,
    PropertyDescription,
    MutatingScreenKind,
} from "../description";
import { ActionDescriptor } from "./action-descriptor";
import { SerializedComponent } from "../../components/SerializedApp";
import { panic } from "../../Support";
import { ComponentBuilder, ComponentConfiguratorContext } from "../components";
import { BaseActionHandler, tokenForProperty } from "./base";
import { DescriptionToken } from "./action-handler";
import { makeTextPropertyDescriptor } from "../components/descriptor-utils";
import { makeText } from "../builder-utils";

interface OpenMapActionDescription extends ActionDescription {
    address?: PropertyDescription;
}

export class OpenMapWithArgsHandler extends BaseActionHandler<OpenMapActionDescription> {
    public readonly kind = ActionKind.OpenMapWithArgs;

    public readonly iconName = "map-pin";

    public getDescriptor(
        _desc: OpenMapActionDescription | undefined,
        _tables: InputOutputTables | undefined,
        _ccc: ComponentConfiguratorContext,
        mutatingScreenKind: MutatingScreenKind | undefined
    ): ActionDescriptor {
        return {
            name: "Show Address on Map",
            needsScreenContext: true,
            properties: [
                makeTextPropertyDescriptor("address", "Address", "Enter address", true, mutatingScreenKind, {
                    preferredNames: ["address", "location"],
                    preferredType: "string",
                    searchable: false,
                    columnFirst: true,
                    applyFormat: false,
                }),
            ],
        };
    }

    public makeAction(
        builder: ComponentBuilder,
        desc: OpenMapActionDescription,
        tables: InputOutputTables,
        screenContext: SerializedComponent | undefined
    ): SerializedComponent | undefined {
        const { b } = builder;
        if (screenContext === undefined) {
            return panic("Must have screen context for View address on map action");
        }

        const address = makeText(builder, desc.address, tables.input, true, false, false, false, screenContext);
        if (address === undefined) return undefined;

        return b.actionIfContextDefined(b.openMap(address));
    }

    public getTokenizedDescription(
        desc: OpenMapActionDescription,
        tables: InputOutputTables,
        ccc: ComponentConfiguratorContext
    ): readonly DescriptionToken[] | undefined {
        const columnToken = tokenForProperty(desc.address, tables, ccc);
        if (columnToken === undefined) return undefined;

        return [columnToken];
    }
}
